export default __webpack_public_path__ + "static/media/FrankPorcelli-min.68c07431.jpeg";